import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function ResidencyInvestmentGibraltar() {

    return (
        <main className='main'>
            <IntroSection
                title="Residency & Investment – Gibraltar"
                subtitle="Secure Residency in a UK-Linked, Low-Tax Jurisdiction"
                description="Gibraltar offers individuals and families the opportunity to gain residency through business establishment, investment, or high-net-worth programs. As a British Overseas Territory, Gibraltar provides direct access to the UK market while maintaining a business-friendly 10% corporate tax system and no VAT, no capital gains, and no inheritance tax."
                badges={[
                    "Investor Residency",
                    "Entrepreneur Residency",
                    "Business Relocation",
                    "High-Net-Worth Programs"
                ]}
                buttonText="Request a Gibraltar Residency Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/residency-passport/gibraltar-hero.png')}
                imageAlt="Gibraltar Residency & Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Gibraltar Residency?"
                        blocks={[
                            {
                                items: [
                                    { text: "UK Market Access — unique post-Brexit advantage." },
                                    { text: "Low-Tax Environment — 10% corporate tax, no VAT, no capital gains." },
                                    { text: "Business Relocation — move your company and secure residency." },
                                    { text: "Investor & Entrepreneur Routes — tailored for HNWIs and entrepreneurs." },
                                    { text: "Lifestyle — safe, English-speaking, Mediterranean living." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency Pathways in Gibraltar"
                        blocks={[
                            {
                                title: "Investor Residency",
                                items: [
                                    { text: "Residency through significant investments in Gibraltar-based businesses, real estate, or financial services." },
                                    { text: "Designed for high-net-worth individuals (HNWIs)." }
                                ]
                            },
                            {
                                title: "Entrepreneur Residency",
                                items: [
                                    { text: "For individuals establishing or relocating a business in Gibraltar." },
                                    { text: "Especially attractive for fintech, gaming, crypto, and financial services companies." }
                                ]
                            },
                            {
                                title: "Business Relocation Residency",
                                items: [
                                    { text: "Residency obtained by moving an existing offshore or international company into Gibraltar." },
                                    { text: "Ideal for businesses wanting UK access and EU credibility." }
                                ]
                            },
                            {
                                title: "High-Net-Worth Individual (Category 2 Status)",
                                items: [
                                    { text: "Gibraltar offers special tax residency for HNWIs under “Category 2” status." },
                                    { text: "Caps personal tax liability at approx. £37,000–£44,000 annually, regardless of worldwide income." }
                                ]
                            }
                        ]}
                    />

                    />

                    <WhySection
                        title="Tax Benefits of Gibraltar Residency"
                        blocks={[
                            {
                                items: [
                                    { text: "Corporate Tax: 10%." },
                                    { text: "Capital Gains Tax: none." },
                                    { text: "Inheritance Tax: none." },
                                    { text: "Personal Tax: capped for HNWIs (Category 2 status)." },
                                    { text: "No VAT: business-friendly environment." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Gibraltar Residency"
                        blocks={[
                            {
                                items: [
                                    { text: "UK Connection — post-Brexit recognition for business and residency." },
                                    { text: "Wealth & Asset Protection — stable, low-tax environment." },
                                    { text: "Business Friendly — fintech, gaming, insurance, and funds thrive here." },
                                    { text: "Investor Confidence — highly respected financial hub." },
                                    { text: "Lifestyle — Mediterranean climate, English-speaking, safe jurisdiction." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Application Process"
                        blocks={[
                            {
                                items: [
                                    { text: "Consultation — select investor, entrepreneur, or HNWI route." },
                                    { text: "Document Preparation — financial proof, business plan, compliance checks." },
                                    { text: "Application Submission — filed with Gibraltar authorities." },
                                    { text: "Approval & Residency — typically 2–6 months." },
                                    { text: "Pathway to Long-Term Settlement — residency is renewable." }
                                ]
                            }
                        ]}
                    />


                    <FeatureCards
                        title='Why Offshore Advisory?'
                        features={
                            [
                                { text: "Expertise in residency, tax, and corporate structuring" },
                                { text: "End-to-end guidance for investors, entrepreneurs, and HNWIs" },
                                { text: "Integration with banking, tax planning, and corporate relocation" },
                                { text: "Comparative insights: Gibraltar vs Malta vs Isle of Man vs Cyprus" },
                                { text: "Long-term support for renewals and compliance" }
                            ]
                        }
                        />
                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a low-tax residency with UK access?"
                        description="Gibraltar offers investor, entrepreneur, and HNWI residency routes, making it one of the most attractive relocation destinations in Europe."
                        buttonText="Book a Gibraltar Residency Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const testimonialsData = [
    {
        quote: "Gibraltar’s Category 2 residency gave me tax efficiency and UK-linked credibility. Offshore Advisory managed my application.",
        author: "Samuel R.",
        role: "Investor"
    },
    {
        quote: "We relocated our fintech company to Gibraltar. Offshore Advisory handled the residency and business transition.",
        author: "Elena V.",
        role: "Entrepreneur"
    }
];


const faqData = [
    {
        question: "Is Gibraltar part of the UK?",
        answer: "It is a British Overseas Territory, not the UK itself, but enjoys UK market access.",
    },
    {
        question: "What is Category 2 residency?",
        answer: "A special HNWI tax residency capping personal tax liability.",
    },
    {
        question: "How much do I need to invest for residency?",
        answer: "Investor residency: £2m+, Entrepreneur residency: £50k+, Category 2 residency: proof of HNWI + Gibraltar property.",
    },
    {
        question: "How long does approval take?",
        answer: "2–6 months.",
    },
    {
        question: "Can Gibraltar residency lead to UK citizenship?",
        answer: "No — but it grants UK market access and tax benefits.",
    },
];
